import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Observable } from 'rxjs';
import { Opportunity } from './opportunity.model';

@Injectable({
  providedIn: 'root'
})
export class OpportunityService {
  constructor(
    private api: ApiHttpClient
  ) { }

  forBorrower(borrowerId: number): Observable<Opportunity> {
    return this.api.get<Opportunity>(`/borrower-opportunity/${borrowerId}`);
  }
}
